import type { TFunction } from 'i18next'
import type { Notification } from './state'

/**
 * Resolve the display title/message for a notification in the active language.
 *
 * Backend notifications are stored with English text plus an optional `i18nKey`
 * (see backend notificationModel.js). When the key exists in the locale bundle
 * (`notifications.content.<i18nKey>.title/.message`), the localized string wins;
 * otherwise the stored English text is shown unchanged.
 */
export function getNotificationDisplayText(
  notification: Pick<Notification, 'title' | 'message' | 'i18nKey' | 'i18nParams'>,
  t: TFunction,
): { title: string; message: string } {
  const key = notification.i18nKey
  if (key) {
    const params = { ...(notification.i18nParams || {}), defaultValue: '' }
    const title = t(`notifications.content.${key}.title`, params) as string
    const message = t(`notifications.content.${key}.message`, params) as string
    return {
      title: title || notification.title || '',
      message: message || notification.message || '',
    }
  }
  return { title: notification.title || '', message: notification.message || '' }
}
